import React from 'react';
import { Container, Row } from 'reactstrap';
import PathReport from './components/PathReport';

export default function PathReporteIndex() {
  return (
    <Container className="dashboard">
      <Row>
        <PathReport title="AMC Path Report" />
      </Row>
    </Container>
  );
}
